import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { uploadFile } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function postFiles({
  accountId,
  params,
}: TVariables): Promise<TResult> {
  const response = await fetch(uploadFile(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  params: {
    Title: string;
    Content: string;
    Container: string;
    streamContent: string;
  };
};

type TSnapshot = unknown;

function useUploadFile(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async ({ accountId, params }: TVariables) => {
    const renamedResult = await postFiles({ accountId, params });
    if (renamedResult.StatusCode === 200) {
      queryClient.invalidateQueries(['get_file_tree'], {
        refetchInactive: true,
      });
    } else if (renamedResult.StatusCode !== 200) {
      throw renamedResult;
    }
    return renamedResult;
  });
}

export { useUploadFile };
